/**
 * Labstep
 *
 * @module components/OrderRequest/Status/Modal/AddItems
 * @desc Confimation modal to add received items to the inventory
 */

import { ResourceItemActionBulkCreateModalContainer as ResourceItemActionBulkCreateModal } from 'labstep-web/components/ResourceItem/Action/BulkCreate/Modal';
import { ModalConfirmation } from 'labstep-web/core/Modal/Confirmation';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import type { OrderRequestStatusModalAddItemsProps } from './types';

export const OrderRequestStatusModalAddItems: React.FC<
  OrderRequestStatusModalAddItemsProps
> = ({ orderRequest, onImport, ...rest }) => (
  <ModalConfirmation
    confirmButtonContent={false}
    cancelButtonContent="Add later"
    positive
    header={`Add ${ResourceItem.getHumanReadableEntityName(
      true,
      true,
    )}`}
    message={
      <div>
        <p>
          You have {orderRequest.remainingItemsCount} items left to
          add to the inventory.
        </p>
        <p>
          Do you want to add these received items to the inventory?
        </p>
      </div>
    }
    extraButtons={
      <ResourceItemActionBulkCreateModal
        resource={orderRequest.resource}
        orderRequest={orderRequest}
        actionComponentProps={{
          type: 'button',
          text: 'Add now',
        }}
        onImport={onImport}
      />
    }
    {...rest}
  />
);
